(function () {
  if (!location.pathname.startsWith("/apps/track123")) return;

  // Hook for CSS
  document.documentElement.classList.add("is-track123");

  // Read tracking number from URL
  const params = new URLSearchParams(location.search);
  const tracking = params.get("tracking") || "";
  if (!tracking) return;

  function fireEvents(el) {
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
    el.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true }));
  }

  function getInput() {
    return (
      document.querySelector("input.track123_form_input") ||
      document.querySelector("#track123_tracking_number input") ||
      document.querySelector("input.track123_form_field")
    );
  }

  function getButton() {
    return (
      document.querySelector("button.track123_form_button") ||
      Array.from(document.querySelectorAll("button, input[type='submit']")).find(
        (b) => /track/i.test((b.textContent || b.value || "").trim())
      )
    );
  }

  function ensureHero() {
    if (document.getElementById("dlx-track-hero")) return;

    const wrapper = document.getElementById("track123_tracking_number");
    if (!wrapper) return;

    const hero = document.createElement("div");
    hero.id = "dlx-track-hero";
    wrapper.parentNode.insertBefore(hero, wrapper);
  }

  function fillAndSubmit() {
    ensureHero();

    const input = getInput();
    const btn = getButton();
    if (!input || !btn) return false;

    input.focus();
    input.value = tracking;
    fireEvents(input);

    // Auto-submit
    btn.click();
    return true;
  }

  // Retry briefly because app content can render after page load
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (fillAndSubmit() || tries > 30) clearInterval(timer);
  }, 250);
})();
